import { render, staticRenderFns } from "./ConsentVideo.vue?vue&type=template&id=52993f05&scoped=true"
import script from "./ConsentVideo.vue?vue&type=script&lang=js"
export * from "./ConsentVideo.vue?vue&type=script&lang=js"
import style0 from "./ConsentVideo.vue?vue&type=style&index=0&id=52993f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52993f05",
  null
  
)

export default component.exports